export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: '¿Tienes un cupón promocional? Haz click en "Activar" para usarlo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'Su cuenta ha sido cancelada. Suscríbase a un plan para volver a activar su cuenta.',

    //StripeNumberComponent
    change_pay_method: 'Cambiar método de pago',
}